import defaultState from "./state";
import guid from "../../../helpers/guid";

const grillaSolicitudPQReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_PRESTACION_SOLICTUD":
      {
        return Object.assign({}, state, {
          prestacionesSolicitud: state.prestacionesSolicitud.concat(action.prestacionSolicitud),
        });
      }

    case "OPEN_QUITAR_PRESTACION_SOLICITUD":
      {
        return Object.assign({}, state, {
          modalQuitarPrestacionSolicitud: action.modalAction,
          guidFilaQuitar: action.guidFilaQuitar,
        });
      }

    case "OPEN_ELIMINAR_BORRADOR":
      {
        return Object.assign({}, state, {
          modalEliminarBorrador: action.modalAction,
        });
      }

    case "LIMPIAR_SOLICITUD":
      {
        return Object.assign({}, state, {
          prestacionesSolicitud: [],
          idSolicitud: null
        });
      }

    case "UPDATE_ID_DETALLE_PRESTACION_PRESTACIONES":
      {
        const prestacionesSolicitudEditar = [];
        let removeDupsJSON = [];

        action.prestaciones.forEach(e => {
          const str = JSON.stringify(e);

          if (removeDupsJSON.length == 0) {
            removeDupsJSON.push(str);
          }

          if (removeDupsJSON.indexOf(str) == -1) {
            removeDupsJSON.push(str);
          }
        });

        action.prestaciones = removeDupsJSON.map(e => JSON.parse(e));

        for (let i = 0; i < state.prestacionesSolicitud.length; i++) {
          const statePrestacion = state.prestacionesSolicitud[i];
          const IDDETALLEPRESTACION = action.prestaciones[i].IdDetallePrestacion;

          prestacionesSolicitudEditar.push({
            ...statePrestacion,
            IDDETALLEPRESTACION,
          });
        }

        return Object.assign({}, state, {
          idSolicitud: action.IdSolicitud,
          prestacionesSolicitud: prestacionesSolicitudEditar,
        });
      }

    case "UPDATE_ID_SOLICITUD_SAVE_FIRST_TIME_BORRADOR":
      {
        return Object.assign({}, state, {
          idSolicitud: action.idSolicitud
        });
      }

    /* case "CARGAR_DETALLE_SOLICITUD_FIL":
      {
        return Object.assign({}, state, {
          prestacionesSolicitud: action.prestacionesSolicitud,
          idSolicitud: action.idSolicitud
        })
      } */

    case "UPDATE_ID_SOLICITUD":
      {
        return Object.assign({}, state, {
          idSolicitud: action.idSolicitud,
          cargandoBorrador: action.cargandoBorrador,
        });
      }

    case "UPDATE_STATUS_BORRADOR":
      {
        return Object.assign({}, state, {
          cargandoBorrador: action.cargandoBorrador,
        });
      }

    case "QUITAR_PRESTACION_SOLICITUD_SELECCIONADA":
      {
        const guidFilaQuitarAux = state.guidFilaQuitar;
        let aux = [];
        let prestacionesSolicitudAux = [];

        aux = state.prestacionesSolicitud;

        aux.forEach(e => {
          if (e.idPaqueteEditar != guidFilaQuitarAux) {
            prestacionesSolicitudAux.push(e);
          }
        });

        return Object.assign({}, state, {
          prestacionesSolicitud: prestacionesSolicitudAux,
        });
      }

    case "GUARDAR_SOLICITUD_EDITAR_CREACION":
      {
        let prestacionesSolicitudAux = state.prestacionesSolicitud;
        const indexEditar = prestacionesSolicitudAux.findIndex((p) => p.GUID === action.detallePrestacion.rowGuid);
        const prestacionesSolicitudEditar = prestacionesSolicitudAux.filter((p) => p.GUID === action.detallePrestacion.rowGuid)[0];

        prestacionesSolicitudEditar.COD_PRESTADOR = action.detallePrestacion.codigoPrestacionPrestador;
        prestacionesSolicitudEditar.TIPO_PRESTACION = action.detallePrestacion.tipoPrestacion;
        prestacionesSolicitudEditar.GUARISMO = action.detallePrestacion.pabellonPrestacion;
        prestacionesSolicitudEditar.GLOSA_CODPRESTADOR = action.detallePrestacion.glosaPrestacionPrestador;
        prestacionesSolicitudEditar.INICIO_VIG = action.detallePrestacion.inicioVigenciaArancel;
        prestacionesSolicitudEditar.PERTENENCIA_FONASA = action.detallePrestacion.pertenenciaFonasa;
        prestacionesSolicitudEditar.CODIGO_FONASA = action.detallePrestacion.codigoFonasa;
        prestacionesSolicitudEditar.ITEM_IMED = action.detallePrestacion.itemImed;
        prestacionesSolicitudEditar.PROF_CCOD = action.detallePrestacion.tipoProfesional;
        prestacionesSolicitudEditar.UNIDAD = action.detallePrestacion.tipoUnidad;
        prestacionesSolicitudEditar.VALOR = action.detallePrestacion.montoArancelPrestacion;

        prestacionesSolicitudAux = prestacionesSolicitudAux.filter((p) => p.GUID !== action.detallePrestacion.rowGuid);
        prestacionesSolicitudAux.splice(indexEditar, 0, prestacionesSolicitudEditar);

        return Object.assign({}, state, {
          prestacionesSolicitud: prestacionesSolicitudAux,
        });
      }

    case "GUARDAR_SOLICITUD_EDITAR_ELIMINACION":
      {
        let prestacionesSolicitudAux = state.prestacionesSolicitud;
        const indexEditar = prestacionesSolicitudAux.findIndex((p) => p.GUID === action.detallePrestacion.rowGuid);
        const prestacionesSolicitudEditar = prestacionesSolicitudAux.filter((p) => p.GUID === action.detallePrestacion.rowGuid)[0];

        prestacionesSolicitudEditar.FECHA_FIN_VIG = action.detallePrestacion.inicioVigenciaArancel;

        prestacionesSolicitudAux = prestacionesSolicitudAux.filter((p) => p.GUID !== action.detallePrestacion.rowGuid);
        prestacionesSolicitudAux.splice(indexEditar, 0, prestacionesSolicitudEditar);

        return Object.assign({}, state, {
          prestacionesSolicitud: prestacionesSolicitudAux,
        });
      }

    case "GUARDAR_SOLICITUD_EDITAR_MODIFICACION":
      {
        let prestacionesSolicitudAux = state.prestacionesSolicitud;
        const indexEditar = prestacionesSolicitudAux.findIndex((p) => p.GUID === action.detallePrestacion.rowGuid);
        const prestacionesSolicitudEditar = prestacionesSolicitudAux.filter((p) => p.GUID === action.detallePrestacion.rowGuid)[0];

        prestacionesSolicitudEditar.INICIO_VIG = action.detallePrestacion.inicioVigenciaArancel;
        prestacionesSolicitudEditar.UNIDAD = action.detallePrestacion.tipoUnidad;
        prestacionesSolicitudEditar.VALOR = action.detallePrestacion.montoArancelPrestacion;

        prestacionesSolicitudAux = prestacionesSolicitudAux.filter((p) => p.GUID !== action.detallePrestacion.rowGuid);
        prestacionesSolicitudAux.splice(indexEditar, 0, prestacionesSolicitudEditar);

        return Object.assign({}, state, {
          prestacionesSolicitud: prestacionesSolicitudAux,
        });
      }
    case "CARGAR_BORRADOR":
      {
        let IdSolicitudAux = state.idSolicitud;

        //console.log("ESTADO:", state);

        if (IdSolicitudAux === null || typeof IdSolicitudAux == "undefined") {
          IdSolicitudAux = action.detalleBorrador[0].IdSolicitud;
        }
        return Object.assign({}, state, {
          idSolicitud: IdSolicitudAux,
        });
      }

    case "GUARDAR_ESTADO_SOLICITUD":
      {
        const IdSolicitudAux = action.Solicitud[0].IdSolicitud;

        return Object.assign({}, state, {
          idSolicitud: state.idSolicitud.concat(IdSolicitudAux),
        });
      }

    case "OPEN_SOLICITUD_ENVIADA":
      {
        return Object.assign({}, state, {
          loading: false,
          modalSolicitudEnviada: action.modalAction,
        });
      }

    case 'PRESTACIONES_TO_HOMOLOGADOR': {
      const prestacionesToHomologador = [];

      for (const row of action.prestacionesToHomologador) {
        if (row.COD_OPERACION == 1) {
          prestacionesToHomologador.push({
            CodPrestacion: row.COD_PRESTADOR,
            GlosaPrestacion: row.GLOSA_CODPRESTADOR,
            CodTipoProfesional: row.PROF_CCOD,
            Guarismo: row.GUARISMO,
            TipoAtencion: row.TIPO_ATENCION,
            CodFonasa: row.CODIGO_FONASA,
            FechaAtencion: '', // Este dato no se encuentra en las tablas de Aranceles Web. Solo en Homologador.
          });
        }
      }
      return Object.assign({}, state, {
        prestacionesToHomologador: prestacionesToHomologador,
      });
    }

    case 'ID_SOLICITUD_FOR_HOMOLOGADOR': {
      //console.log('action.IdSolicitudForHomologador', action.IdSolicitudForHomologador)
      return Object.assign({}, state, {
        IdSolicitudForHomologador: action.IdSolicitudForHomologador,
      });
    }

    case 'ID_SOLICITUD_HOMOLOGADOR': {
      return Object.assign({}, state, {
        IdSolicitudHomologador: action.IdSolicitudHomologador,
      });
    }

    case 'CREANDO_SOLICITUD': {
      return Object.assign({}, state, {
        creando: action.cantidad,
      });
    }

    case 'PRESTACIONES_HOMOLOGADAS': {
      const prestacionesHomologadas = [];

      for (const row of action.prestacionesHomologadas) {
        prestacionesHomologadas.push({
          idSolicitud: row.idSolicitud,
          CodigoIsapre: row.CodigoIsapre,
          CodigoProfIsapre: row.CodigoProfIsapre,
          CodPrestacion: row.CodPrestacion,
          CodTipoProfesional: row.CodTipoProfesional,
          TipoAtencion: row.TipoAtencion,
          FechaAtencion: row.FechaAtencion,
        });
      }
      return Object.assign({}, state, {
        prestacionesHomologadas: prestacionesHomologadas,
      });
    }

    default:
      return state;
  }
};

export default grillaSolicitudPQReducer;



// WEBPACK FOOTER //
// ./src/components/Paquetes/GrillaSolicitud/reducer.js